import SimpleBoxForm from "atoms/Forms/SimpleBoxForm";
import { EmailJobRecordType } from "pages/SharedRecords.types";
import { useState } from "react";
import { CreateBase, useRefresh } from "react-admin";

import ComposeEmailFormContent from "./ComposeEmailFormContent";
import { EmailToolbar } from "./index";
import { ComposeEmailFormPropsType } from "./SendEmailDialog.types";

export default function ComposeEmailForm(props: ComposeEmailFormPropsType) {
  const {
    availableFiles = [],
    event,
    closeDialog,
    recipients,
    templates,
    withGeneratedDocument = false,
    onBackClick,
    onSuccess,
  } = props;

  const [previewContent, setPreviewContent] = useState<string>("");
  const [showPreview, setShowPreview] = useState(false);
  const refresh = useRefresh();

  const defaultTemplate = templates.find((template) => template.is_default) || templates[0];

  const defaultValues = {
    template: defaultTemplate.id,
    sender: defaultTemplate.sender,
    subject: defaultTemplate.subject,
    recipients: recipients,
  };

  return (
    <CreateBase
      resource="email_jobs"
      mutationOptions={{
        onSuccess: () => {
          closeDialog?.();
          refresh();
          onSuccess?.();
        },
      }}
      transform={(data: EmailJobRecordType) => {
        return { ...data, scheduled_at: data.scheduled_at ? data.scheduled_at : undefined };
      }}
    >
      <SimpleBoxForm
        data-testid="compose-email-form"
        toolbar={
          <EmailToolbar
            event={event}
            onBackClick={onBackClick}
            setShowPreview={setShowPreview}
            setPreviewContent={setPreviewContent}
            showPreview={showPreview}
          />
        }
        defaultValues={defaultValues}
        resource="email_jobs"
      >
        <ComposeEmailFormContent
          templates={templates}
          defaultTemplate={defaultTemplate}
          availableFiles={availableFiles}
          showPreview={showPreview}
          previewContent={previewContent}
          withGeneratedDocument={withGeneratedDocument}
          recipients={recipients}
        />
      </SimpleBoxForm>
    </CreateBase>
  );
}
